import { useState } from "react";
import { useApi } from "providers/ProvideApi";
import { wrapError } from "../../utils";
import { useAlert } from "advancement-solutions-components/dist/providers";

export const useAddChapter = (topic) => {
  const { authApi } = useApi();
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const { send } = useAlert();

  const update = async (chapter) => {
    try {
      setIsUpdating(true);
      setError(null);
      const response = await authApi.post(
        `/api/topics/${topic.id}/chapters/${chapter.id}`,
        chapter
      );
      setData(response.data);
      send({ message: "Chapter updated.", severity: "info" });
    } catch (e) {
      const error = wrapError(e);
      send({
        message: `Chapter was not updated: ${error.message}`,
        severity: "error",
      });
      setError(error);
    } finally {
      setIsUpdating(false);
    }
  };

  return [data, update, isUpdating, error];
};

export default useAddChapter;
